import { render, staticRenderFns } from "./ModalAddBatch.vue?vue&type=template&id=6ccb09ba&scoped=true"
import script from "./ModalAddBatch.vue?vue&type=script&lang=js"
export * from "./ModalAddBatch.vue?vue&type=script&lang=js"
import style0 from "./ModalAddBatch.vue?vue&type=style&index=0&id=6ccb09ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccb09ba",
  null
  
)

export default component.exports